module.exports = __webpack_public_path__ + "img/img5.9dbeff02.svg";